(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment confirmed status
    module.directive('searchTipsIcon', ['$sce', '$translate', function ($sce, $translate) {
        var directive = {
            restrict: 'E',     
            replace: true,
            templateUrl: '/app/global/templates/search-tips-icon.html',
            link: link
        };
        return directive;

        function link(scope, element) {    
            scope.htmlSearchTips =  $sce.trustAsHtml($translate.instant('search_tips_html'));            
        }
    }]);

})();